<form class="flex flex-col form-field-wrapper" [formGroup]="form" *ngIf="isLoaded"> 
  <mat-label class="flex flex-row items-center gap-2">
    {{ label | translate }}
    <span *ngIf="required">*</span>
    <app-icon
      *ngIf="infoTooltip"
      class="cursor-pointer"
      [matTooltip]="infoTooltip | translate"
      iconName="info"
      size="sm"
      fill="#1f5792"
      matTooltipPosition="above"></app-icon>
  </mat-label>

  <mat-form-field class="w-full">
    <mat-date-range-input [rangePicker]="picker" #dateRangeInput>
      <input [placeholder]="fromPlaceholder | translate" formControlName="start" matStartDate />
      <input [placeholder]="toPlaceholder | translate" formControlName="end" matEndDate />
    </mat-date-range-input>

    <button mat-icon-button matSuffix type="button" (click)="clearDatePicker()" *ngIf="showClearBtn && !disabled">
      <mat-icon>clear</mat-icon>
    </button>

    <mat-datepicker-toggle [for]="picker" matSuffix></mat-datepicker-toggle>
    <mat-date-range-picker #picker></mat-date-range-picker>
  </mat-form-field>
</form>